import React, { Component } from 'react';
import {
    List,
    Pagination,
} from 'react-admin';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const RoleListTable = ({ ids, data, basePath }) => (
    <Table style={{ marginLeft: '12px', marginRight: '12px' }}>
        <TableHead>
            <TableRow>
                <TableCell padding="none">ID</TableCell>
                <TableCell padding="none">Name</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {ids.map(id => {
                const row = data[id];
                return (
                    <TableRow key={row['id']}>
                        <TableCell padding="none">{row['id']}</TableCell>
                        <TableCell padding="none">{row['name']}</TableCell>
                    </TableRow>
                );
            })}
        </TableBody>
    </Table>
);

class RoleList extends Component {
    render() {
        return (
            <List title="Roles" {...this.props} pagination={<Pagination rowsPerPageOptions={[]} />}>
                <RoleListTable />
            </List>
        );
    }
}

export default RoleList;